import React from 'react';
import moment from 'moment';
import { getCityNameByKLADR } from '../../../helpers/cityCodes';

moment.locale('ru');

const Card = props => {
  const times = [];
  if (props.NEXT_EVENT_DATE ? moment(props.NEXT_EVENT_DATE).format('HH:mm') != '00:00' : false) {
    times.push(moment(props.NEXT_EVENT_DATE).format('HH:mm'));
  } else if (moment(props.START_DATE).format('HH:mm') != '00:00') {
    times.push(moment(props.START_DATE).format('HH:mm'));
  }

  const cityStr = getCityNameByKLADR(props.NEXT_EVENT_CITY_CODE || props.CITY_CODE);

  const dateFrom = props.productCard
    ? 'В любое время'
    : props.START_DATE
    ? moment(props.START_DATE).format('D MMMM')
    : moment(props.NEXT_EVENT_DATE).format('D MMMM');

  const dateCityInfo = `${dateFrom}, ${cityStr}`

  const fromPage = window.location.pathname != '/' ? 'playbill' : 'front';

  return (
    <li className="card cards__card">
      <a
        className="card__info"
        href={`${
          props.EVENT_PAGE
            ? props.EVENT_PAGE.DETAIL_PAGE_URL
            : props.DETAIL_PAGE_URL
        }?from=${fromPage}`}
      >
        <h4 className={'card__title'}>{props.SHORT_NAME ? props.SHORT_NAME : props.NAME} </h4>

        <p className="card__bottom">
          <span className="date">
            <svg>
              <use href="/static/img/icons/icons.svg#i-calendar"></use>
            </svg>
            <span>{dateCityInfo}</span>
          </span>
          {times.length == 0 || props.productCard ? null : (
            <span className="time">
              <svg>
                <use href="/static/img/icons/icons.svg#i-clock"></use>
              </svg>
              <span>{times.join(' — ')}</span>
            </span>
          )}
        </p>
      </a>
    </li>
  );
};

export default Card;
